import React from 'react';
import PropTypes from 'prop-types';
import { TAG_SELECTOR_PREFIX } from 'Render/utils/importers';
import {
  ORGANISATION_LINE_ITEM_ID,
  ORGANISATION_INVENTORY_ID,
  ORGANISATION_AUDIENCE_ID,
  ORGANISATION_AUDIENCE_SEGMENT_ID,
  ORGANISATION_AUDIENCE_CUSTOM,
} from 'Render/tracking/constants/trackingNames';
import dv360Tracking from './dv360.js';
import scriptForHTMLTag from './tag.js'; // eslint-disable-next-line

class HTMLTag extends React.PureComponent {
  constructor(props) {
    super(props);
    this.componentDidMount = this.runScript;
    this.componentDidUpdate = this.runScript;
    this.state = {
      key: 0,
    };
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.loaderURL !== this.props.loaderURL) {
      this.setState(({ key }) => ({ key: (key + 1) }));
    } else if (nextProps.payloadURL !== this.props.payloadURL) {
      this.setState(({ key }) => ({ key: (key + 1) }));
    }
  }
  getThirdPartyImpression() {
    const { thirdPartyImpression } = this.props;
    return JSON.stringify(thirdPartyImpression);
  }
  getParametersForScript() {
    const {
      adId,
      placementId,
      loaderURL,
      payloadURL,
      trackingURL,
      ascm,
      macros,
      organisationLineItemID,
      organisationInventoryID,
      organisationAudienceId,
      organisationAudienceSegmentId,
      organisationAudienceCustom,
    } = this.props;

    const params = [
      'window',
      'document',
      `'${loaderURL}'`,
      `'${payloadURL}'`,
      `'${trackingURL}'`,
      placementId,
      adId,
      'new Image()',
      `${this.getThirdPartyImpression()}`,
      `'${ascm}'`,
      macros,
      `'${organisationLineItemID}'`,
      `'${organisationInventoryID}'`,
      `'${organisationAudienceId}'`,
      `'${organisationAudienceSegmentId}'`,
      `'${organisationAudienceCustom}'`,
    ];
    return `(${params.join()})`;
  }

  getScript() {
    const errorScript = `${scriptForHTMLTag}`.replace(/"/g, "'");
    const tagParams = `${this.getParametersForScript()}`;
    return `<img src="data:image/png,ivo" style="display:none;" onerror="(${errorScript})${tagParams}" />`;
  }
  runScript() {
    const { runScript } = this.props;
    if (!runScript) return;
    const scriptTag = this.instance.firstChild;
    eval(scriptTag.innerHTML); // eslint-disable-line
  }
  render() {
    const {
      placementId,
      environment,
      tracking,
      children
    } = this.props;
    const { key } = this.state;
    const isDV360 = (environment === 'dv360');
    if (isDV360) {
      return (
        <div
          id={`${TAG_SELECTOR_PREFIX}-${placementId}`}
          ref={el => (this.instance = el)}
          key={key}
        >
          <script dangerouslySetInnerHTML={{ __html: dv360Tracking() }} />
          <div
            dangerouslySetInnerHTML={{ __html: this.getScript() }}
          />
        </div>
      );
    }
    return (
      <div
        id={`${TAG_SELECTOR_PREFIX}-${placementId}`}
        ref={el => (this.instance = el)}
        key={key}
        dangerouslySetInnerHTML={{ __html: this.getScript() }}
      />
    );
  }
}


HTMLTag.propTypes = {
  adId: PropTypes.number.isRequired,
  loaderURL: PropTypes.string,
  payloadURL: PropTypes.string.isRequired,
  placementId: PropTypes.number,
  ascm: PropTypes.string,
  macros: PropTypes.string,
  environment: PropTypes.string,
  tracking: PropTypes.string,
  organisationLineItemID: PropTypes.string,
  organisationInventoryID: PropTypes.string,
  organisationAudienceId: PropTypes.string,
  organisationAudienceSegmentId: PropTypes.string,
  organisationAudienceCustom: PropTypes.string,
  thirdPartyImpression: PropTypes.array, // eslint-disable-line
  trackingURL: PropTypes.string,
  runScript: PropTypes.bool,
};

HTMLTag.defaultProps = {
  thirdPartyImpression: [],
  loaderURL: '',
  trackingURL: '',
  ascm: '',
  environment: '',
  tracking: '',
  macros: '{}',
  organisationLineItemID: '',
  organisationInventoryID: '',
  organisationAudienceId: '',
  organisationAudienceSegmentId: '',
  organisationAudienceCustom: '',
  runScript: true,
  placementId: 0,
};

export default HTMLTag;



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Render/components/HTMLTag/HTMLTag.jsx